import { configureStore } from '@reduxjs/toolkit';
import staticReducer from '../features/states/app/staticSlice';
import headerReducer from '../features/states/header/headerSlice';
import loaderReducer from '../features/states/loader/loaderSlice';
import loginReducer from '../features/states/login/loginSlice';

export default configureStore({
  reducer: {
    login: loginReducer,
    header: headerReducer,
    loader: loaderReducer,
    static: staticReducer,
  },
});
